// tslint:disable:component-selector
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { DealerOption } from '../../../model/dealer/dealer-option';

@Component({
  selector: 'rti-dealer-option-detail',
  templateUrl: './rti-dealer-option-detail.html',
  styleUrls: ['./rti-dealer-option-detail.scss']
})

export class RtiDealerOptionDetail implements OnInit {
  @Input() style: any;
  @Input() model: DealerOption;

  ngOnInit() {
  }

  constructor() {
    this.model = new DealerOption();
    this.style = {
      maxHeight: '350px',
      width: '700px',
    };
  }
}
